import { useState } from 'react';

import Button from '~/components/common/Button';
import Heading from '~/components/common/Heading';
import { useGameContext } from '~/contextProviders/GameContextProvider';
import { calculateAttackBonus } from '~/utils/utils';

export function BattleChooseAttack({
  onSelect,
  onCancel,
  showCancel,
  warrior,
}) {
  const { tournamentParam, battle } = useGameContext();
  const isPeaceful = tournamentParam === 'peaceful';
  const [activeAtttack, setActiveAttack] = useState<string | undefined>();
  const attacks = ['Water', 'Timber', 'Metal', 'Earth', 'Fire'].map(
    (attack) => (
      <button
        className={`attack-option attack-option--${attack.toLowerCase()}`}
        key={attack}
        onClick={() => onSelect(attack.toLowerCase())}
        onMouseEnter={() => setActiveAttack(attack.toLowerCase())}
        onMouseLeave={() => setActiveAttack(undefined)}
      >
        <div
          className="attack-option__bonus"
          data-id={calculateAttackBonus(
            attack.toLowerCase(),
            warrior,
            tournamentParam,
            battle,
          )}
        >
          <span className="attack-option__bonus-label">
            +{' '}
            {calculateAttackBonus(
              attack.toLowerCase(),
              warrior,
              tournamentParam,
              battle
            )}{' '}
            HP
          </span>
        </div>
        <div
          className={`attack-option__icon attack-option__icon--${attack.toLowerCase()}`}
        >
          <img
            src={
              isPeaceful ?
                `/img/peaceful/${attack.toLowerCase()}.png` :
                `/img/syndicate.${attack.toLowerCase()}.png`
            }
            alt={attack}
            className="attack-option__icon-img"
          />
        </div>
        <span className="attack-label">{attack}</span>
        <div
          className={`attack-option__beats attack-option__beats-${attack.toLowerCase()}`}
        >
          <img src="/img/arrow-up.png" alt="Up" />
          <span className="attack-option__beats-label">Beats</span>
        </div>
      </button>
    )
  );
  return (
    <div className="battle-choose-attack">
      <Heading level={4}>Choose Attack</Heading>
      <div
        className={`attack-options ${
          activeAtttack !== undefined &&
          `attack-options--${activeAtttack}-active`
        }`}
      >
        {attacks}
      </div>
      <Button
        label="Cancel"
        className="warrior__attack__confirm__button secondary"
        onClick={onCancel}
        style={{
          visibility: showCancel ? 'visible' : 'hidden',
        }}
      />
    </div>
  );
}
